import React, { useCallback, useEffect, useRef } from 'react';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'actions/auth';
import Loader from 'components/atoms/Spinner/Loader';
import UserContainer from 'components/user/container/UserContainer';
import { Language } from 'language/Language';
import { strings } from './strings';

const AccountDetails = ({ history }) => {

  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state);
  const language = Language();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const params = new URLSearchParams(window.location.search);
  const redirectTo = params.get('redirectTo');
  const hasRedirectedRef = useRef(false);

  const handleLoginRedirect = useCallback(() => {
    if (!redirectTo || hasRedirectedRef.current) {
      return;
    }

    hasRedirectedRef.current = true;

    const isJapanLanguage = language === 'japan';
    const url = isJapanLanguage ? `jp/${redirectTo || ''}` : redirectTo || '';

    params.delete('type');
    params.delete('redirectTo');

    const cleanUrl = `${window.location.pathname}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    window.history.replaceState({}, '', cleanUrl);
    history.push(`/${url}`);
  }, [history, language, params, redirectTo]);

  useEffect(() => {
    if (!redirectTo || hasRedirectedRef.current) return;

    const timeout = setTimeout(() => {
      handleLoginRedirect();
    }, 4000);

    return () => clearTimeout(timeout);
  }, [handleLoginRedirect, redirectTo]);

  const EnString = () => (
    <p>
      {strings[language].hello}
      <strong>
        {userInfo.displayName}
      </strong>
      {strings[language].not}
      <strong>
        {userInfo.displayName}
        {'?'}
      </strong>
      <strong style={{ cursor: 'pointer' }} onClick={() => dispatch(logout(history, language === 'japan' ? '/jp/私のアカウント' : '/my-account'))}>{strings[language].logout}</strong>
      )
    </p>
  );

  const JpStrings = () => (
    <p>
      <strong>
        {userInfo.displayName}
      </strong>
      {strings.japan.hello}
      <strong>
        {userInfo.displayName}
      </strong>
      {strings.japan.not}
      <strong style={{ cursor: 'pointer' }} onClick={() => dispatch(logout())}>{strings.japan.logout}</strong>
      {strings.japan.not2}
    </p>
  );

  if (userInfo && redirectTo) {
    return (
      <div style={{
        minHeight: '80vh', display: 'flex', alignContent: 'center', justifyContent: 'center', flexDirection: 'column',
      }}
      >
        <Loader />
        <h2 color='white' style={{ textAlign: 'center' }}>Redirecting you to the payment page</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet title={language === 'japan' ? '私のアカウント - Walkmix Creator' : 'My Account - Walkmix Creator'} />
      <UserContainer>
        <div>
          {language === 'english'
            ? (
              <EnString />
            )
            : (
              <JpStrings />
            )}
          <p>{strings[language].info}</p>
        </div>
      </UserContainer>
    </>
  );
};

export default AccountDetails;
